import type { FC, ReactNode } from 'react'

import Link from 'next/link'

export const Footer: FC = (): ReactNode => {
    const year = new Date().getFullYear()

    return (
        <div className='footer'>
            <div className='container'>
                <div className='footer-wrapper'>
                    <div className='footer-brand-holder'>
                        <Link href='/' className='footer-brand w-inline-block'>
                            <img src='/images/Logo-Black.svg' alt='Black Plus' className='footer-image' />
                        </Link>
                        <p className='grey-text'>© {year} Company.</p>
                    </div>

                    <div className='footer-content'>
                        <div className='footer-block'>
                            <div className='title-small'>Company</div>
                            <Link href='/features' className='footer-link'>Features</Link>
                            <Link href='/about' className='footer-link'>About</Link>
                            <Link href='/pricing' className='footer-link'>Pricing</Link>
                            <Link href='/blog' className='footer-link'>Blog</Link>
                            <Link href='/contact' className='footer-link'>Contact</Link>
                        </div>

                        <div className='footer-block'>
                            <div className='title-small'>Follow us</div>
                            <a href='https://linkedin.com' target='_blank' rel='noreferrer' className='footer-link'>Linkedin</a>
                            <a href='https://instagram.com' target='_blank' rel='noreferrer' className='footer-link'>Instagram</a>
                            <a href='https://fb.com' target='_blank' rel='noreferrer' className='footer-link'>Facebook</a>
                            <a href='https://twitter.com' target='_blank' rel='noreferrer' className='footer-link'>Twitter</a>
                            <a href='https://pinterest.com' target='_blank' rel='noreferrer' className='footer-link'>Pinterest</a>
                        </div>

                        <div className='footer-block'>
                            <div className='title-small'>Others</div>
                            <Link href='/404' className='footer-link'>404</Link>
                            <Link href='/401' className='footer-link'>Password</Link>
                            <Link href='/' className='footer-link'>Home</Link>
                        </div>
                    </div>
                </div>

                <div className='footer-divider'>
                    <p className='grey-text'>Crafted with ♥ by <a href='https://azwedo.com' target='_blank' rel='noreferrer' className='black-link'>Azwedo</a> &amp; <a href='https://modulify.ai' target='_blank' rel='noreferrer' className='black-link'>Modulify.ai</a></p>
                </div>
            </div>
        </div>
    )
}
